import React, {PropTypes} from "react";

const LedgerTable = (props) => {
  let ledger = props.props;
  return (
    <div className="col-md-5" style={{paddingRight: 0, marginTop: '1%'}}>
      <div className="inner-col-wrap">
        <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
          <thead>
          <tr>
            <th>Leave Ledger</th>
            <th></th>
            <th></th>
          </tr>

          <tr>
            <th>Type</th>
            <th>As on</th>
            <th>Count</th>
          </tr>
          </thead>
          <tbody>
          {ledger.map((node)=> {
            if (node.type == 'initial')
              return <tr>
                <td style={{width: '50%'}}>{node.reason == null ? "Initial Leaves" : node.reason}</td>
                <td>{node.asOnDate.substr(0, 11)}</td>
                <td>{node.leaveCount}</td>
              </tr>
            else
              return <tr>
                <td>{node.reason}</td>
                <td>{node.asOnDate.substr(0, 11)}</td>
                <td>{node.leaveCount}</td>
              </tr>
          })}
          </tbody>
        </table>

      </div>
    </div>
  );

}

LedgerTable.proptypes = {};

export default LedgerTable;



/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveApply/LedgerTable.js
 **/